/* eslint-disable no-unused-vars */
import { useSelector } from 'react-redux';
import { TransactionsSection } from './components/transactionsSection/TransactionsSection';
import { Balance } from './components/balanceSection/Balance';
import { PaymentMethodsSection } from './components/paymentMethodsSection/PaymentMethodsSection';
import * as S from './PaymentsContent.styled';

export const PaymentsContent = () => {
  return (
    <S.Box>
      <Balance fieldName='currentBalance' />
      <Balance fieldName='billingTreshold' />
      <S.Container>
        <PaymentMethodsSection />
      </S.Container>
      <S.Container>
        <TransactionsSection />
      </S.Container>
    </S.Box>
  );
};
